import { useQuery } from '@tanstack/react-query';

import { ensureAgentHubBrands } from '~/consts/agentHub';

import useCurrentBrand from '~/hooks/useCurrentBrand';

import { listAgencies } from '~/services/AgentHub/AgentService';

import { ListAgencyParams } from '~/types/services/agentHub';

export const agenciesQueryKeys = {
  all: ['agencies'] as const,
  lists: () => [...agenciesQueryKeys.all, 'list'] as const,
  list: (params: ListAgencyParams) => [...agenciesQueryKeys.lists(), params] as const,
};

interface UseListAgenciesOptions {
  enabled?: boolean;
}

const FIVE_MINUTES = 5 * 60 * 1000;

export function useListAgencies(params: ListAgencyParams, options: UseListAgenciesOptions = {}) {
  const { enabled = true } = options;
  const brand = useCurrentBrand();

  return useQuery({
    placeholderData: (prev) => {
      return {
        rows: prev?.rows ?? [],
        total: prev?.total ?? 0,
      };
    },
    queryKey: agenciesQueryKeys.list({ ...params, brand: ensureAgentHubBrands(brand) }),
    queryFn: async () => {
      return await listAgencies({ ...params, brand: ensureAgentHubBrands(brand) });
    },
    enabled,
    staleTime: FIVE_MINUTES,
  });
}
